import PropTypes from 'prop-types';
import ArrowRightIcon from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

export const OverviewSingle = (props) => {
  const {
    value,
    title = 'Done Tasks',
    imgIcon = '/assets/iconly/iconly-glass-tick.svg',
    button = null,
    onClicked,
  } = props;

  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
      <Stack
        alignItems="center"
        direction={{
          xs: 'column',
          sm: 'row',
        }}
        spacing={1}
        sx={{
          px: 2,
          py: 1,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={imgIcon} width={48} alt={`${title} Icon`} />
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Typography color="text.primary" variant="body2" sx={{ mb: 1 }}>
            {title}
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '1.25rem',
              // letterSpacing: 1,
              textAlign: { xs: 'center', sm: 'left' }, // Center text in mobile view
            }}
          >
            {value}
          </Typography>
        </Box>
      </Stack>

      {button && (
        <>
          <Divider />
          <CardActions>
            <Button
              color="inherit"
              endIcon={
                <SvgIcon>
                  <ArrowRightIcon />
                </SvgIcon>
              }
              size="small"
              onClick={onClicked}
            >
              {button}
            </Button>
          </CardActions>
        </>
      )}
    </Card>
  );
};

OverviewSingle.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string,
  imgIcon: PropTypes.string,
  button: PropTypes.string,
  onClicked: PropTypes.func,
};
